import React from 'react'
import { Flex } from '@components'
import {
    Button,
    Modal,
    Spin,
    message,
    Form
} from 'antd'
import SiderMenu from '@pages/Assembly/siderMenu'
import Breadcrumb from '@pages/Assembly/Breadcrumb'
import NHFetch from '@utils/NHFetch'
import { getLoginUser, createUuid } from '@utils/NHCore'
import JtcyForm from './fixedClass/JtcyForm'
import GrxxForm from './fixedClass/grxxForm'
import CommonTip from '../common'
import NextButton from '@pages/SelfHelp/common/nextIndex'
import { mkbz } from '@pages/Assembly/siderMenu/menuObj'
import Hint from '@pages/SelfHelp/common/hint'
import './index.css'

const { confirm } = Modal;

class FamilyInformation extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            mkbz: 'GD001_11',
            hjmc: '',
            initData: [],
            familyList: [],
            xsid: '',
            nextUrl: '', //左侧菜单加载完后传进来
            search: '',
            operable: true, //是否显示环节
            nonOperationalData: {}, //不可操作的数据
            menuList: [],
            zzbdhjid: '',
            isSubmiting: false, // 是否正在提交
            refresh: 0,
            resubmitAble: false, //是否可以重新提交
            loading: true,

            isGe: null,
            isDq: null
        }
    }

    componentDidMount() {
        this.queryQztjAndYlhj()
        this.getData4Yxwz()
    }

    //查询前置条件和依赖环节
    queryQztjAndYlhj = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : ''
        if (!xsid) {
            this.setState({
                nonOperationalData: { nologin: true },
                operable: false,
            })
            return
        }
        let zzbdhjid = this.getQueryString('pkid')

        NHFetch('/zzbd/queryQztjAndYlhj', 'GET', {
            xsid: xsid,
            zzbdhjid: zzbdhjid,
        }).then(res => {
            if (res && res.data) {
                let kfsj = res.data['kfsj']
                let ylhj = res.data['ylhj']
                let qzhj = res.data['qzhj']
                let nohj = res.data['nohj']
                let operable = !(
                    (kfsj && kfsj['YXSJ'] != '1') ||
                    (ylhj && ylhj.length > 0) ||
                    (qzhj && qzhj.length > 0) ||
                    nohj
                )
                this.setState(
                    {
                        nonOperationalData: res.data,
                        zzbdhjid: zzbdhjid,
                        operable: operable,
                    },
                    () => {
                        this.getHjBlZt(xsid)
                    }
                )
            }
        })
    }

    getQueryString = name => {
        return (
            decodeURIComponent(
                (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
                    location.href
                ) || [, ''])[1].replace(/\+/g, '%20')
            ) || null
        )
    }

    setMenuList = menuList => {
        let nextCount = 0
        let bz = this.state.mkbz
        menuList.map((elem, index) => {
            if (elem.HJDM == bz) {
                let hjmc = elem.HJMC
                this.setState({ hjmc: hjmc })
                nextCount = index + 1
                return
            }
        })
        let menu = menuList[nextCount]
        if (menu) {
            let hjdm = menu.HJDM
            if (hjdm.indexOf('GD') == 0) {
                let gdUrl = mkbz[hjdm]
                this.setState({
                    nextUrl: gdUrl,
                    search: 'pkid=' + menu.PKID,
                })
            } else if (hjdm.indexOf('ZDY') == 0) {
                let zdyUrl = '/customLink'
                this.setState({
                    nextUrl: zdyUrl,
                    search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX,
                })
            }
        } else {
            this.setState({
                nextUrl: '',
                search: '',
            })
        }
    }


    // 获取各环节信息
    getData4Yxwz = () => {
        let userId = getLoginUser() ? getLoginUser().userId : undefined
        if (userId) {
            this.setState({ xsid: userId })
            NHFetch('/zzbd/getFamilyMembers', 'GET', { xsid: userId }).then(res => {
                if (res && res.code === 200 && res.data) {
                    let data = res.data;
                    // 检查是否存在父亲和母亲
                    const hasFather = data.familyList?.some(item => item.GX === "父亲");
                    const hasMother = data.familyList?.some(item => item.GX === "母亲");
                    const familyList = (data.familyList || []).map(item => {
                        let i = {
                            ...item,
                            key: createUuid(),
                        }
                        // 如果同时存在父亲和母亲，则都不可编辑
                        // 如果只有父亲或母亲之一，则可编辑
                        if (item.GX === "父亲" || item.GX === "母亲") {
                            i.gxEditable = !(hasFather && hasMother);
                        }
                        return i;
                    });

                    let isGe = res.data.isGe
                    let isDq = res.data.isDq
                    this.setState({
                        initData: data,
                        familyList,
                        isGe,
                        isDq
                    }, () => {
                        let grqk = "0";
                        if (isDq == '是') {
                            grqk = "1"; // 单亲家庭
                        } else if (isGe == '是') {
                            grqk = "2"; // 孤儿
                        }
                        setTimeout(() => {
                            this.refs.refJtcyForm.initByGrqk(grqk)
                        }, 500)
                    })
                }
            }).finally(() => {
                this.setState({ loading: false })
            })
        } else {
            message.error('登录超时,请重新登录！')
        }
    }

    // 获取自助报到环节办理状态
    getHjBlZt = xsid => {
        NHFetch(`/zzbd/getBlztByHjdm`, 'GET', {
            xsid,
            hjdm: this.state.mkbz,
        }).then(res => {
            if (!res || res.code !== 200) return
            this.setState({ editable: res.data !== '1' })
        })
    }

    //重新加载菜单
    reloadMenu = () => {
        console.log('reload')
        this.refs.siderMenu.reloadMenuList()
    }

    showConfirm = () => {
        this.props.form.validateFields((err, values) => {
            if (err) {
                return
            }
            let isGe = this.state.isGe
            let isDq = this.state.isDq
            // 将familyList对象转换为数组
            const familyArray = values.familyList ? Object.values(values.familyList) : [];
            if (!(isGe == '是') && familyArray.length === 0) {
                message.info('请填写家庭信息！');
                return;
            }


            const params = { ...values, familyList: familyArray, isGe, isDq};

            confirm({
                title: '确定提交？',
                onOk: async () => {
                    this.setState({
                        isSubmiting: true,
                    })
                    const res = await NHFetch("/zzbd/saveFamilyMembers", "POST", params);

                    this.setState({
                        isSubmiting: false,
                    })
                    if (res && res.code === 200 && res.data == 1) {
                        const userId = getLoginUser().userId;
                        let postData = { xsid: userId, zzbdhjid: this.getQueryString('pkid') };
                        const res2 = await NHFetch('/zzbd/commonSaveLinkTransactionStatus', 'POST', postData)

                        if (res2 && res2.data === 1) {
                            message.success("办理成功");
                            this.getData4Yxwz();
                            this.reloadMenu();
                            this.getHjBlZt(userId);
                        } else {
                            message.error("办理失败，请联系管理员");
                        }
                    }
                },
                onCancel() { },
            })
        })
    }

    // 取消办理
    cancel = () => {
        confirm({
            title: '确定取消？',
            onOk: () => {
                const { xsid, zzbdhjid } = this.state
                const userId = getLoginUser().userId
                this.setState({
                    isSubmiting: true,
                })
                NHFetch(`/zzbd/cancelXscjxxZt?xsid=${xsid}&zzbdhjid=${zzbdhjid}`, 'POST').then((res) => {
                    if (res && res.code === 200) {
                        message.success('取消办理成功')
                        this.getHjBlZt(userId)
                        this.reloadMenu()
                    } else {
                        message.error('取消办理失败')
                    }
                    this.setState({
                        isSubmiting: false,
                    })
                })
            }
        })
    }

    // 表单联动
    onGrxxFormChange = (flag) => {
        this.refs.refJtcyForm.initByGrqk(flag)
    }

    render() {
        const { form } = this.props;
        const { editable, isSubmiting, refresh, loading, familyList } = this.state
        const componentList = []

        if (!loading) {
            // componentList.push(
            //     <GrxxForm
            //         ref='refGrxxForm'
            //         form={form}
            //         dkqkInitData={this.state.initData}
            //         editable={editable} // 如果已提交，就不可编辑
            //         refresh={refresh}
            //         onChange={this.onGrxxFormChange}
            //     />
            // )
            componentList.push(
                <JtcyForm
                    ref={"refJtcyForm"}
                    form={form}
                    jtcyInitData={familyList}
                    editable={editable} // 如果已提交，就不可编辑
                    refresh={refresh}
                    isRequired={true}
                />
            )
        }

        return (
            <div>
                {this.state.operable ? (
                    <Flex className='w1180 mt-20' styleName='updateInfo' align='start' style={{ width: '100%', maxWidth: '1400px' }}>
                        <SiderMenu
                            ref={'siderMenu'}
                            setMenuList={this.setMenuList}
                            title='自助报到'
                            mkbz={this.state.mkbz}
                            menuType='自助报到'
                        />
                        <Spin spinning={isSubmiting} wrapperClassName='updateInfoSpin'>
                            <Flex.Item className='page_con_r' style={{ maxWidth: '100%', minWidth: 0, overflow: 'hidden' }}>
                                <Breadcrumb
                                    noLine
                                    list={[
                                        { name: '首页', url: '/index' },
                                        { name: '自助报到', url: '/register' },
                                        { name: this.state.hjmc },
                                    ]}
                                />
                                <div className='box'>
                                    <Hint />
                                    {/* 流程 */}
                                    {componentList && componentList.length != 0 ? componentList
                                        : <span style={{ margin: 20 }}>暂未配置个人信息采集环节参数</span>}

                                    <div className='p-sw text-center mt-30'>
                                        {editable && (componentList && componentList.length != 0) && (
                                            <Button type='primary' onClick={this.showConfirm}>
                                                提交
                                            </Button>
                                        )}

                                        {
                                            !editable && (
                                                <Button type='primary' onClick={this.cancel}>
                                                    取消提交
                                                </Button>
                                            )
                                        }
                                        <NextButton
                                            nextUrl={this.state.nextUrl}
                                            search={this.state.search}
                                        />
                                    </div>
                                </div>
                            </Flex.Item>
                        </Spin>
                    </Flex>
                ) : (
                    <CommonTip
                        hjmc={'家庭信息采集'}
                        key={'GD001_11'}
                        mkbz='GD001_11'
                        nonOperationalData={this.state.nonOperationalData}
                    />
                )}
            </div>
        )
    }
}
const FamilyInformationForm = Form.create()(FamilyInformation)
export default FamilyInformationForm